import { Copy } from 'lucide-react';
import { Button } from '@sara/ui/components/button';
import { toast } from '@sara/ui/components/sonner';

interface CopyFieldButtonProps {
  value: string;
  label: string;
}

/**
 * Floating "Copy" icon button positioned in the top-right of a `relative`
 * container (typically a textarea wrapper). Hides itself when the field is
 * empty so empty inputs don't get a button that does nothing useful.
 */
export function CopyFieldButton({ value, label }: CopyFieldButtonProps) {
  const trimmed = value.trim();
  if (!trimmed) return null;

  async function handleClick() {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(`Copied ${label}`);
    } catch {
      toast.error('Copy failed — select and copy manually.');
    }
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      className="absolute right-1.5 top-1.5 z-10 h-7 w-7 rounded-md text-muted-foreground/70 hover:text-foreground"
      onClick={handleClick}
      aria-label={`Copy ${label}`}
      title={`Copy ${label}`}
    >
      <Copy className="h-3.5 w-3.5" strokeWidth={1.6} />
    </Button>
  );
}
